const cruiseRouters = [
  {
    route: null,
    name: null,
    title: '游船管理',
    type: 'folder',
    icon: 'iconfont icon-yunyingguanli_fuwufenzuguanli',
    isElementIcon: false,
    filePath: 'view/cruise',
    order: 8,
    inNav: true,
    permission: ['游船航线列表', '船票商品列表', '游船时段列表', '日期例外配置列表'],
    children: [
      {
        title: '航线管理',
        type: 'view',
        name: 'CruiseRouteList',
        route: '/cruise/route/list',
        filePath: 'view/cruise/route/index.vue',
        inNav: true,
        icon: 'iconfont icon-tushuguanli',
        isElementIcon: false,
        permission: ['游船航线列表'],
      },
      {
        title: '票种管理',
        type: 'view',
        name: 'CruiseTicketProductList',
        route: '/cruise/ticket/list',
        filePath: 'view/cruise/ticket/index.vue',
        inNav: true,
        icon: 'iconfont icon-tushuguanli',
        isElementIcon: false,
        permission: ['船票商品列表'],
      },
      {
        title: '时段管理',
        type: 'view',
        name: 'CruiseSlotList',
        route: '/cruise/slot/list',
        filePath: 'view/cruise/slot/index.vue',
        inNav: true,
        icon: 'iconfont icon-tushuguanli',
        isElementIcon: false,
        permission: ['游船时段列表'],
      },
      {
        title: '日期例外配置',
        type: 'view',
        name: 'CruiseScheduleList',
        route: '/cruise/schedule/list',
        filePath: 'view/cruise/schedule/index.vue',
        inNav: true,
        icon: 'iconfont icon-houtaiguanli',
        isElementIcon: false,
        permission: ['日期例外配置列表'],
      },
    ],
  },
  {
    route: null,
    name: null,
    title: '订单管理',
    type: 'folder',
    icon: 'iconfont icon-rizhiguanli',
    isElementIcon: false,
    filePath: 'view/cruise/order',
    order: 8.1,
    inNav: true,
    permission: ['游船订单列表'],
    children: [
      {
        title: '订单列表',
        type: 'view',
        name: 'CruiseOrderList',
        route: '/cruise/order/list',
        filePath: 'view/cruise/order/index.vue',
        inNav: true,
        icon: 'iconfont icon-rizhiguanli',
        isElementIcon: false,
        permission: ['游船订单列表'],
      },
      {
        title: '订单详情',
        type: 'view',
        name: 'CruiseOrderDetail',
        route: '/cruise/order/detail',
        filePath: 'view/cruise/order/detail.vue',
        inNav: false,
        icon: 'iconfont icon-rizhiguanli',
        isElementIcon: false,
        permission: ['游船订单列表'],
      },
    ],
  },
  {
    route: null,
    name: null,
    title: '核销管理',
    type: 'folder',
    icon: 'iconfont icon-rizhiguanli',
    isElementIcon: false,
    filePath: 'view/cruise/verify',
    order: 8.2,
    inNav: true,
    permission: ['船票核验', '核销记录列表'],
    children: [
      {
        title: '船票核验',
        type: 'view',
        name: 'CruiseTicketVerify',
        route: '/cruise/verify/check',
        filePath: 'view/cruise/verify/check.vue',
        inNav: true,
        icon: 'iconfont icon-icon-test',
        isElementIcon: false,
        permission: ['船票核验'],
      },
      {
        title: '核销记录',
        type: 'view',
        name: 'CruiseVerifyRecordList',
        route: '/cruise/verify/list',
        filePath: 'view/cruise/verify/index.vue',
        inNav: true,
        icon: 'iconfont icon-icon-test',
        isElementIcon: false,
        permission: ['核销记录列表'],
      },
    ],
  },
]

export default cruiseRouters
